import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import Button from '../Button';
import ConfirmAlert from '../ConfirmAlert';
import resx from '../../../utilities/resx';
import saveComment from '../../../API/SaveComment';
import { withMessage } from '../Message';
import loggly from '../../../API/Loggly';
import mixpanel from '../../../API/Mixpanel';
import { LOGGLY_LEVEL_ERROR, MIXPANEL_DELETE, RESX_GLOBAL, RESX_REBLASTS, RESX_DASHBOARD } from '../../../Constants';

const DeleteComment = props => {
    const { setState, commentId, message } = props;
    const [loading, setLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    let loadingTimer;
    const handleDropdownClick = () => {
        setShowDropdown(!showDropdown);
    };

    const handleDeleteClick = () => {
        ConfirmAlert({
            description: resx(RESX_REBLASTS, 'REBLASTS_DELETE_COMMENT'),
            confirmLabel: resx(RESX_DASHBOARD, 'DASHBOARD_CONTACT_DELETE'),
            abortLabel: resx(RESX_REBLASTS, 'CANCEL_TEXT')
        }).then(() => {
            loadingTimer = setTimeout(() => {
                setLoading(true);
            }, 1000);
            saveComment
                .delete(commentId)
                .then(response => {
                    if (!_path(['data', 'SaveCommentResult', 'Success'], response)) {
                        throw new Error(_path(['data', 'SaveCommentResult', 'Message'], response));
                    }
                    mixpanel.add(MIXPANEL_DELETE, { content: 'Comment Text' });
                    clearTimeout(loadingTimer);
                    setLoading(false);
                    setState(prevState => ({
                        ...prevState,
                        Comments: prevState.Comments.filter(comment => comment.CommentId !== commentId)
                    }));
                })
                .catch(error => {
                    clearTimeout(loadingTimer);
                    setLoading(false);
                    message.addMessage({
                        message: resx(RESX_GLOBAL, 'GENERIC_WEBSERVICE_ERROR_MESSAGE'),
                        type: 'error'
                    });
                    loggly.add(LOGGLY_LEVEL_ERROR, `Reblast comment could not be deleted: ${error}`);
                });
        });
    };

    return (
        <React.Fragment>
            <button
                type="button"
                className="reblast-dropdown re-icon re-icon-xs re-icon-dropDown re-btn-cancel"
                onClick={handleDropdownClick}
                onBlur={() => {
                    setTimeout(() => {
                        setShowDropdown(false);
                    }, 250);
                }}
            />
            {showDropdown ? (
                <div className="reblast-menu-items">
                    <Button
                        type="button"
                        className="re-btn re-btn-cancel re-btn-small"
                        loading={loading}
                        text={resx(RESX_GLOBAL, 'DELETE_TEXT')}
                        onClick={handleDeleteClick}
                        dataTestid="delete-comment"
                    />
                </div>
            ) : null}
        </React.Fragment>
    );
};

DeleteComment.propTypes = {
    commentId: PropTypes.string.isRequired,
    message: PropTypes.object,
    setState: PropTypes.func.isRequired
};

export default withMessage(DeleteComment);
